/**
 * Export a XLSX — el ÚNICO camino (auditoría de reutilización 23/09/2026: había
 * 2 copias inline —InventoryPage, CommunityMapPage— con la misma silueta
 * json_to_sheet → book_new → book_append_sheet → writeFile). Mismo guard
 * anti-fórmula que csv.ts: una celda que empieza con = + - @ se ejecuta al
 * abrir el archivo en Excel.
 *
 * 26/10/2026: `xlsx` (SheetJS 0.18.5, dos advisories HIGH sin fix en npm —
 * prototype pollution y ReDoS al LEER archivos; acá solo se escribe) se reemplazó
 * por `write-excel-file` (solo escritura, 1,8 MB vs 7 MB, mantenido en npm). La
 * firma de `downloadXlsx` es la misma salvo que ahora devuelve la promesa de la
 * descarga: quien la llama la espera o la deja correr, pero un error ya no se
 * pierde en silencio.
 */
import writeXlsxFile from 'write-excel-file/browser';

export interface DownloadXlsxOptions {
  /** Nombre de la hoja (máx. 31 caracteres por límite de Excel). */
  sheet?: string;
  /** Ancho de columnas en caracteres; si falta, se calcula del contenido (mín. 8, máx. 60). */
  colWidths?: number[];
}

export function xlsxCell(v: unknown): string | number | boolean | null {
  if (v === null || v === undefined) return null;
  if (typeof v === 'number' || typeof v === 'boolean') return v;
  const str = String(v);
  return /^[=+\-@\t\r]/.test(str) ? `'${str}` : str;
}

/** Arma el libro (encabezados en negrita + filas) y dispara la descarga. */
export function downloadXlsx(filename: string, headers: string[], rows: unknown[][], opts: DownloadXlsxOptions = {}): Promise<void> {
  const header = headers.map((h) => ({ value: h, fontWeight: 'bold' as const }));
  // Celda vacía = null (no `{ value: null }`): así lo pide write-excel-file.
  const body = rows.map((r) => headers.map((_, i) => { const v = xlsxCell(r[i]); return v === null ? null : { value: v }; }));
  const widths = opts.colWidths ?? headers.map((h, i) => {
    const longest = rows.reduce((m, r) => Math.max(m, String(r[i] ?? '').length), h.length);
    return Math.min(60, Math.max(8, longest + 2));
  });
  return writeXlsxFile([header, ...body], {
    columns: widths.map((width) => ({ width })),
    sheet: (opts.sheet ?? 'Datos').slice(0, 31),
  }).toFile(filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
}
